module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/app-store-badge-b853888aa8abf2da313e34656632ceb8.svg";